import { cn } from '@virginexperiencedays/tailwind';

type CollectionChoiceOverlayContentSkeletonProps = {
  className?: string;
};

export const CollectionChoiceOverlayContentSkeleton = ({
  className,
}: CollectionChoiceOverlayContentSkeletonProps) => {
  return (
    <div
      className={cn(
        className,
        'flex-col gap-4',
        'overflow-y-auto overflow-x-hidden hide-scrollbar',
        // drawer
        // 90dvh less heights of drawer handle, section heading,
        // the gap between product title and this, and drawer body padding bottom respectively
        'max-h-[calc(90dvh_-_(20px_+_22px_+_16px_+_16px))] pb-10',
        // modal
        'md:max-h-none md:overflow-y-visible md:pb-0'
      )}
      data-testid="collection-choice-overlay-content-skeleton"
    >
      <section className="flex animate-pulse flex-col gap-2">
        <div className="h-5 w-4/5 bg-background-neutral-faded lg:h-[22px]" data-testid="title" />
        <div className="mb-3 h-5 w-10 bg-background-neutral-faded" data-testid="rating" />
      </section>
      <section
        className="relative flex animate-pulse flex-col border-b border-solid border-border-neutral dark:border-persistent-text-light"
        data-testid="content-container"
      >
        <div
          className="mb-6 h-[277px] w-full rounded-lg bg-background-neutral-faded sm:h-[340px]"
          data-testid="media"
        />
        <div
          className="mb-4 h-5 w-2/5 bg-background-neutral-faded lg:h-[22px]"
          data-testid="about-title"
        />
        <div className="mb-2 h-5 w-full bg-background-neutral-faded" data-testid="about-content" />
        <div className="mb-6 h-6 w-20 bg-background-neutral-faded" data-testid="read-more" />
        <div
          className="mb-4 h-5 w-2/5 bg-background-neutral-faded lg:h-[22px]"
          data-testid="whats-included-title"
        />
        <ul data-testid="whats-included-list">
          <li
            className="mb-6 ml-10 h-6 w-4/5 bg-background-neutral-faded"
            data-testid="whats-included-el-1"
          />
          <li
            className="mb-6 ml-10 h-6 w-3/5 bg-background-neutral-faded"
            data-testid="whats-included-el-2"
          />
          <li
            className="mb-6 ml-10 h-6 w-9/12 bg-background-neutral-faded"
            data-testid="whats-included-el-3"
          />
          <li
            className="mb-6 ml-10 h-6 w-4/6 bg-background-neutral-faded"
            data-testid="whats-included-el-4"
          />
        </ul>
      </section>
      <section
        className="relative flex animate-pulse flex-col border-b border-solid border-border-neutral dark:border-persistent-text-light"
        data-testid="location-container"
      >
        <div
          className="mb-4 h-[22px] w-1/5 bg-background-neutral-faded"
          data-testid="location-title"
        />
        <div
          className="mb-4 h-[22px] w-2/5 bg-background-neutral-faded"
          data-testid="location-location"
        />
        <div
          className="mb-4 h-[400px] w-full rounded-lg bg-background-neutral-faded"
          data-testid="location-map"
        />
        <div
          className="mb-6 ml-auto h-4 w-3/5 bg-background-neutral-faded"
          data-testid="location-disclaimer"
        />
      </section>
      <div className="relative mt-2 flex animate-pulse flex-col" data-testid="button-container">
        <div
          className="mb-10 h-14 w-full bg-background-neutral-faded"
          data-testid="button-placeholder"
        />
      </div>
    </div>
  );
};
